import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class PrimaryIndustryService {
  private readonly primaryIndustryBaseApiUrl: string;

  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.primaryIndustryBaseApiUrl = `${baseUrl}api/industries`;
  }

  public getIndustries() {
    let primaryIndustryApiUrl = `${this.primaryIndustryBaseApiUrl}/`;

    return this.dataService.get<any>(primaryIndustryApiUrl);
  }
}
